/*
  節の地の色の割りふり (案C2)。ページの頭、真ん中、終わりに色を1つずつ置く。
  - ゆめさくエンジニアとは (#about) 黄の帯。節の頭から見出しの下までだけ黄。本文と図は生成りの方眼のまま
  - 作るもの (#projects) 青の全面。上下を斜めに切る。切り口の大きさは --cut (390 で 32px、900px から 56px)
  - 手に入る15のもの (#what-you-get) 黄の全面
  色は hp-base.ts の変数を使う。補助の灰の字は、黄の上だけ --yellow-sub (墨に近い灰) に替える。
*/
export const RHYTHM_CSS = `
.hp{--yellow-sub:#454A52;--cut:32px}
@media (min-width:900px){.hp{--cut:56px}}

/* 黄の帯。旗、名前、見出しをくくる hx-about-head に黄を敷く。左右は画面の端まで広げ、節の overflow で切る */
.hp #about{overflow:hidden}
.hp .hx-about-head{position:relative;isolation:isolate;padding-bottom:32px}
.hp .hx-about-head::before{content:"";position:absolute;z-index:-1;top:calc(var(--sec) * -1);bottom:0;left:-100vw;right:-100vw;background:var(--yellow)}
/* 帯の下端から本文まで 28px あける */
.hp .hx-about-lede{margin-top:28px}

/* 黄の全面 */
.hp .hx-yellow{background:var(--yellow);--sub:var(--yellow-sub)}
.hp .hx-yellow .hx-k{color:var(--ink)}

/* 青の全面。上下を斜めに切り、隣の節の地を三角に見せる。切り口の分だけ隣に食い込ませて余白を足す */
.hp .hx-blue{position:relative;z-index:1;background:var(--blue);margin:calc(var(--cut) * -1) 0;padding-top:calc(var(--sec) + var(--cut));padding-bottom:calc(var(--sec) + var(--cut));clip-path:polygon(0 var(--cut),100% 0,100% calc(100% - var(--cut)),0 100%)}
.hp .hx-blue .hx-head{color:#fff;--sub:rgba(255,255,255,.86)}
.hp .hx-blue .hx-flag{background:#fff;color:var(--blue)}
.hp .hx-blue .hx-k{color:#fff}
.hp .hx-blue .hx-b-em,.hp .hx-blue .hx-head .px-em{color:var(--yellow);background:none}
`;
